import { KalturaImage } from '@kaltura-ott/ott-client-types/api/types/KalturaImage';
import { KuxCategoriesDTO } from '@kaltura-ott/tvpil';

export const offlineLauncherData: KuxCategoriesDTO = {
  name: 'Root TV11',
  multilingualName: [],
  id: 6661,
  images: [] as KalturaImage[],
  metas: {
    background_color: '#06062d',
    font_type: 'OpenSans',
    font_size: 1.2,
    text_color: '#ffffff',
    focus_color: '#ffffff',
    selected_color: '#ffffff',
    hide_adult_assets: true,
    hide_adult_assets_kSQL: "(and adult='0')",
    hide_parental_assets: false,
    CategoryId: 6661,
    asset_image_height: 250,
    CatalogStartDateTime: 1593686700,
  },
  channels: [],
  unifiedChannels: [],
  tags: {
    UIDA_presentation_type: 'container',
    asset_presentation_form: 'circle',
    UIDA_structure_type: 'root',
  },
  originTags: {},
  structId: 0,
  children: [
    {
      name: 'Root Main Menu',
      multilingualName: [],
      id: 7318,
      images: [] as KalturaImage[],
      metas: {
        CategoryId: 7318,
        CatalogStartDateTime: 1594644053,
      },
      channels: [364792],
      unifiedChannels: [],
      tags: {
        UIDA_presentation_type: 'menu',
        UIDA_structure_type: 'menu',
      },
      originTags: {},
      structId: 0,
      children: [],
      virtualAssetId: 0,
      referenceId: '',
    },
    {
      name: 'Home Page',
      multilingualName: [],
      id: 6663,
      images: [] as KalturaImage[],
      metas: {
        hide_adult_assets: false,
        present_player: true,
        CategoryId: 6663,
        CatalogStartDateTime: 1593687099,
      },
      channels: [],
      unifiedChannels: [],
      tags: {
        UIDA_presentation_type: 'container',
        UIDA_structure_type: 'page',
      },
      originTags: {},
      structId: 0,
      children: [
        {
          name: 'Main Menu',
          multilingualName: [],
          id: 7311,
          images: [] as KalturaImage[],
          metas: {
            CategoryId: 7311,
            CatalogStartDateTime: 1594628986,
          },
          channels: [364662],
          unifiedChannels: [],
          tags: {
            UIDA_presentation_type: 'menu',
            UIDA_structure_type: 'menu',
          },
          originTags: {},
          structId: 0,
          children: [],
          virtualAssetId: 0,
          referenceId: '',
        },
        {
          name: 'Apps',
          multilingualName: [],
          id: 7634,
          images: [] as KalturaImage[],
          metas: {
            device_brand_denial_list_for_ui_components: '2,3,4,5',
            CategoryId: 7634,
            CatalogStartDateTime: 1595837738,
          },
          channels: [],
          unifiedChannels: [],
          tags: {
            UIDA_presentation_type: 'apps',
            UIDA_structure_type: 'widget',
          },
          originTags: {},
          structId: 0,
          children: [],
          virtualAssetId: 0,
          referenceId: '',
        },
      ],
      virtualAssetId: 0,
      referenceId: '',
    },
    {
      name: 'Home Page',
      multilingualName: [],
      id: 6663,
      images: [] as KalturaImage[],
      metas: {
        hide_adult_assets: false,
        present_player: true,
        CategoryId: 6663,
        CatalogStartDateTime: 1593687099,
      },
      channels: [],
      unifiedChannels: [],
      tags: {
        UIDA_presentation_type: 'applications',
        UIDA_structure_type: 'page',
      },
      originTags: {},
      structId: 0,
      children: [],
      virtualAssetId: 0,
      referenceId: '',
    },
    {
      name: 'Additional Pages',
      multilingualName: [],
      id: 8244,
      images: [] as KalturaImage[],
      metas: {
        CategoryId: 8244,
        CatalogStartDateTime: 1600006078,
      },
      channels: [],
      unifiedChannels: [],
      tags: {
        UIDA_presentation_type: 'folder',
        UIDA_structure_type: 'aside',
      },
      originTags: {},
      structId: 0,
      children: [
        {
          name: 'Applications',
          multilingualName: [],
          id: 8245,
          images: [] as KalturaImage[],
          metas: {
            CategoryId: 8245,
            focus_color: '',
            background_color: '',
            text_color: '',
            font_type: '',
            selected_color: '',
            font_size: 0,
            asset_image_height: 0,
            rail_items_limit: 0,
            present_show_more: false,
            CatalogStartDateTime: 1600006084,
          },
          channels: [],
          unifiedChannels: [],
          tags: {
            UIDA_presentation_type: 'applications',
            UIDA_structure_type: 'page',
            device_brand_denial_list_for_ui_components: '1',
          },
          originTags: {},
          structId: 0,
          children: [
            {
              name: 'Top Menu',
              multilingualName: [],
              id: 8563,
              images: [] as KalturaImage[],
              metas: {
                CategoryId: 8563,
                focus_color: '',
                background_color: '',
                text_color: '',
                font_type: '',
                selected_color: '',
                font_size: 0,
                filtering_kSQL: '',
                present_entitlement_indicator: false,
                hide_adult_assets: false,
                present_favorite_indicator: false,
                hide_parental_assets: false,
                hide_adult_assets_kSQL: '',
                hide_parental_assets_kSQL: '',
                default_channel: 0,
                present_X_most_watched_period: 0,
                present_X_most_watched_count: 0,
                present_current_programs: false,
                program_refresh_frequency: 0,
                asset_image_height: 0,
                CatalogStartDateTime: 1600852029,
              },
              channels: [364897],
              unifiedChannels: [
                {
                  id: 364897,
                  name: 'New Menu',
                },
              ],
              tags: {
                UIDA_presentation_type: 'menu',
                UIDA_structure_type: 'menu',
              },
              originTags: {},
              structId: 0,
              children: [],
              virtualAssetId: 0,
              referenceId: '',
            },
            {
              name: 'Applications',
              multilingualName: [],
              id: 8458,
              images: [] as KalturaImage[],
              metas: {
                CategoryId: 8458,
                focus_color: '',
                background_color: '',
                text_color: '',
                font_type: '',
                selected_color: '',
                font_size: 0,
                asset_image_height: 0,
                rail_items_limit: 0,
                present_show_more: false,
                CatalogStartDateTime: 1600767652,
              },
              channels: [],
              unifiedChannels: [],
              tags: {
                UIDA_presentation_type: 'apps',
                UIDA_structure_type: 'widget',
              },
              originTags: {},
              structId: 0,
              children: [],
              virtualAssetId: 0,
              referenceId: '',
            },
            {
              name: 'Games',
              multilingualName: [],
              id: 8459,
              images: [] as KalturaImage[],
              metas: {
                CategoryId: 8459,
                focus_color: '',
                background_color: '',
                text_color: '',
                font_type: '',
                selected_color: '',
                font_size: 0,
                asset_image_height: 0,
                rail_items_limit: 0,
                present_show_more: false,
                CatalogStartDateTime: 1600767725,
              },
              channels: [],
              unifiedChannels: [],
              tags: {
                UIDA_presentation_type: 'apps',
                UIDA_structure_type: 'widget',
              },
              originTags: {},
              structId: 0,
              children: [],
              virtualAssetId: 0,
              referenceId: '',
            },
          ],
          virtualAssetId: 0,
          referenceId: '',
        },
        {
          name: ' Package Page',
          multilingualName: [],
          id: 8246,
          images: [] as KalturaImage[],
          metas: {
            CategoryId: 8246,
            focus_color: '',
            background_color: '',
            text_color: '',
            font_type: '',
            selected_color: '',
            font_size: 20,
            asset_image_height: 1080,
            asset_struct: 'Package',
            CatalogStartDateTime: 1600006094,
          },
          channels: [],
          unifiedChannels: [],
          tags: {
            UIDA_presentation_type: 'asset_details_page',
            UIDA_structure_type: 'page',
            asset_presentation_ratio: '16x9',
            asset_presentation_form: 'landscape',
          },
          originTags: {},
          structId: 0,
          children: [],
          virtualAssetId: 0,
          referenceId: '',
        },
        {
          name: 'Movie Page',
          multilingualName: [],
          id: 8247,
          images: [] as KalturaImage[],
          metas: {
            CategoryId: 8247,
            focus_color: '',
            background_color: '',
            text_color: '',
            font_type: '',
            selected_color: '',
            font_size: 0,
            asset_image_height: 600,
            asset_struct: 'Movie',
            CatalogStartDateTime: 1600006104,
          },
          channels: [],
          unifiedChannels: [],
          tags: {
            UIDA_presentation_type: 'asset_details_page',
            UIDA_structure_type: 'page',
            asset_presentation_ratio: '2x3',
            asset_presentation_form: 'posters',
          },
          originTags: {},
          structId: 0,
          children: [],
          virtualAssetId: 0,
          referenceId: '',
        },
        {
          name: 'Default Asset Page',
          multilingualName: [],
          id: 8248,
          images: [] as KalturaImage[],
          metas: {
            CategoryId: 8248,
            focus_color: '',
            background_color: '#3358FF',
            text_color: '',
            font_type: '',
            selected_color: '',
            font_size: 0,
            asset_image_height: 300,
            asset_struct: 'Default',
            CatalogStartDateTime: 1600006115,
          },
          channels: [],
          unifiedChannels: [],
          tags: {
            UIDA_presentation_type: 'asset_details_page',
            UIDA_structure_type: 'page',
            asset_presentation_ratio: '16x9',
            asset_presentation_form: 'landscape',
          },
          originTags: {},
          structId: 0,
          children: [],
          virtualAssetId: 0,
          referenceId: '',
        },
        {
          name: 'Zapper',
          multilingualName: [],
          id: 8249,
          images: [] as KalturaImage[],
          metas: {
            CategoryId: 8249,
            focus_color: '#ffffff',
            background_color: '#000000',
            text_color: '#ffffff',
            font_type: '',
            selected_color: '',
            font_size: 14,
            filtering_kSQL: '',
            hide_adult_assets: true,
            hide_parental_assets: false,
            hide_adult_assets_kSQL: '',
            asset_image_height: 0,
            CatalogStartDateTime: 1600006119,
          },
          channels: [364718],
          unifiedChannels: [
            {
              id: 364718,
              name: 'All Linear',
            },
          ],
          tags: {
            UIDA_presentation_type: 'zapper',
            UIDA_structure_type: 'widget',
            asset_presentation_ratio: '16x9',
          },
          originTags: {},
          structId: 0,
          children: [],
          virtualAssetId: 0,
          referenceId: '',
        },

        {
          name: 'Program Page',
          multilingualName: [],
          id: 9107,
          images: [] as KalturaImage[],
          metas: {
            CategoryId: 9107,
            focus_color: '',
            background_color: '',
            text_color: '#F333FF',
            font_type: '',
            selected_color: '',
            font_size: 20,
            asset_image_height: 400,
            asset_struct: 'Program',
            CatalogStartDateTime: 1602149040,
          },
          channels: [],
          unifiedChannels: [],
          tags: {
            UIDA_presentation_type: 'asset_details_page',
            UIDA_structure_type: 'page',
            asset_presentation_ratio: '2x3',
            asset_presentation_form: 'posters',
          },
          originTags: {},
          structId: 0,
          children: [],
          virtualAssetId: 0,
          referenceId: '',
        },
      ],
      virtualAssetId: 0,
      referenceId: '',
    },
  ],
  virtualAssetId: 0,
  referenceId: '',
};
